/* eslint-disable import/no-cycle */
import { call, delay, put, takeLatest } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import * as types from '../../source/actionTypes';
import {
  setSourceList,
  setSourceDetails,
  createSourceSuccess,
  createSourceFailure,
  updateSourceStatusSuccess,
} from '../../source/actions';
import {
  getSourceListApi,
  createSourceApi,
  getSourceDetailApi,
  updateSourceStatusApi,
} from '../requests/sourceRequest';
import { startLoader, stopLoader } from '../../../utility/commonFunction';

function* getSourceListHandler(action) {
  if (action.payload?.search) {
    yield delay(1000);
  }
  try {
    yield startLoader('transparent');
    const params = action?.payload || {};
    const { data } = yield call(getSourceListApi, params);
    const sourceList = data?.status ? data?.data : {};
    if (sourceList) {
      yield put(setSourceList(sourceList));
    }
    if (!data?.status && data?.errors?.message) {
      yield toast.error(data?.errors?.message);
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to fetch source list');
  } finally {
    yield stopLoader('transparent');
  }
}

function* createSourceHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(createSourceApi, action.payload);
    if (data?.status) {
      yield put(createSourceSuccess(true));
      yield toast.success(data?.message || 'Source created successfully');
    } else {
      const formErrors = data?.errors?.form_errors ?? data?.form_errors;
      const failurePayload = formErrors
        ? { form_errors: formErrors }
        : data?.errors ?? { message: data?.errors?.message };
      yield put(createSourceFailure(failurePayload));
      if (!formErrors) {
        yield toast.error(data?.errors?.message || 'Failed to create source');
      }
    }
  } catch (error) {
    const responseData = error?.response?.data;
    const formErrors = responseData?.form_errors ?? responseData?.errors?.form_errors;
    const failurePayload = formErrors ? { form_errors: formErrors } : { response: { data: responseData } };
    yield put(createSourceFailure(failurePayload));
    if (!formErrors) {
      yield toast.error(responseData?.message || 'Failed to create source');
    }
  } finally {
    yield stopLoader('transparent');
  }
}

function* getSourceDetailHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(getSourceDetailApi, action.payload.id);
    if (data?.status && data?.data) {
      yield put(setSourceDetails(data.data));
    } else {
      yield toast.error(data?.errors?.message || 'Failed to fetch source details');
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to fetch source details');
  } finally {
    yield stopLoader('transparent');
  }
}

function* updateSourceStatusHandler(action) {
  try {
    yield startLoader('transparent');
    const { data } = yield call(updateSourceStatusApi, action.payload.id, action.payload.status);
    if (data?.status) {
      yield put(
        updateSourceStatusSuccess({
          id: action.payload.id,
          status: action.payload.status,
        }),
      );
      yield toast.success(data?.message || 'Source status updated successfully');
    } else {
      yield toast.error(data?.errors?.message || data?.message || 'Failed to update source status');
    }
  } catch (error) {
    yield toast.error(error?.response?.data?.message || 'Failed to update source status');
  } finally {
    yield stopLoader('transparent');
  }
}

export default function* sourceSaga() {
  yield takeLatest(types.GET_SOURCE_LIST, getSourceListHandler);
  yield takeLatest(types.CREATE_SOURCE, createSourceHandler);
  yield takeLatest(types.GET_SOURCE_DETAILS, getSourceDetailHandler);
  yield takeLatest(types.UPDATE_SOURCE_STATUS, updateSourceStatusHandler);
}
